// extracted by mini-css-extract-plugin
export default {"chat":"chat_chat__D9gsb","chat__chatHeader":"chat_chat__chatHeader__nYVFQ","chat__chatBody":"chat_chat__chatBody__1tiwM"};